// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const aerodactyl_mega: PokeData = {
  "id": 10042,
  "name": "aerodactyl-mega",
  "height": 21,
  "weight": 790,
  "base_experience": 215,
  "types": [
    PokeType.ROCK,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "fly",
    "take-down",
    "bite",
    "roar",
    "supersonic",
    "hyper-beam",
    "rock-throw",
    "agility",
    "rock-slide",
    "scary-face",
    "crunch",
    "ancient-power",
    "giga-impact",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "iron-head",
    "sky-drop"
  ],
  "moves": [
    "bite",
    "supersonic",
    "rock-throw",
    "rock-slide",
    "scary-face",
    "crunch",
    "ancient-power",
    "thunder-fang",
    "ice-fang",
    "fire-fang",
    "acrobatics",
    "stealth-rock",
    "stone-crush"
  ],
  "evolution_chain": {
    "id": 71,
    "item": null,
    "species": [
      {
        "name": "aerodactyl",
        "order": 173,
        "types": [
          PokeType.ROCK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 92,
    "speed": 162,
    "ability_power": 146
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
